import script from "./CanvasTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CanvasTemplate.vue?vue&type=style&index=0&id=96d1cf00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96d1cf00"]])

export default __exports__